import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["to"]


export default /*@__PURE__*/_defineComponent({
  __name: 'IntroButton',
  props: {
    to: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "btn btn--dark",
    to: _ctx.to ?? ''
  }, [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})